<div *ngIf="formData" class='modal-main-content-cont'>
  <ng-container *ngTemplateOutlet="header"></ng-container>

  <div class="modal-body">
    <div class="container-fluid">

      <div class="modal-intro">
        Please provide the following information to connect<br>
        your {{ title | titlecase }} instance:
        <div class="reveal-credentials" *ngIf="hasCredentials" (click)="revealCredentials()"
          [ngClass]="{'revealed': credentialsRevealed, 'loading': credentialsLoading}"
          ngbTooltip="{{ credentialsRevealed ? 'Credentials visible' : 'Show credentials' }}"
          placement="bottom" container="body">
          <div *ngIf="!credentialsLoading" class="eye-icon" cygovSvgIcon
            [svgName]="credentialsRevealed ? 'eye' : 'mask-eye'"></div>
          <div *ngIf="credentialsLoading" class="eye-spinner"></div>
        </div>
      </div>

      <ng-container [ngSwitch]="serviceName">

        <ng-container *ngSwitchCase="'tenable'">
          <ng-container *ngTemplateOutlet="switchableModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="'nessus'">
          <ng-container *ngTemplateOutlet="switchableModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.AZURE">
          <ng-container *ngTemplateOutlet="azureModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.MICROSOFT">
          <ng-container *ngTemplateOutlet="azureModal; context: {formData: formData}">
          </ng-container>
        </ng-container>


        <ng-container *ngSwitchCase="Integration.AWSSECURITYHUB">
          <ng-container *ngTemplateOutlet="awsModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.SNYK">
          <ng-container *ngTemplateOutlet="snykModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.INTUNE">
          <ng-container *ngTemplateOutlet="intuneModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.SENTINEL">
          <ng-container *ngTemplateOutlet="sentinelModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.SENTINELONE">
          <ng-container *ngTemplateOutlet="sentineloneModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.WIZ">
          <ng-container *ngTemplateOutlet="wizModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.SPLUNK">
          <ng-container *ngTemplateOutlet="splunkModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.OKTA">
          <ng-container *ngTemplateOutlet="oktaModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.ORCA">
          <ng-container *ngTemplateOutlet="orcaModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.DUO">
          <ng-container *ngTemplateOutlet="duoModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.GITHUBSECURITY">
          <ng-container *ngTemplateOutlet="githubSecurityModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.GITLAB">
          <ng-container *ngTemplateOutlet="gitlabModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.VERACODE">
          <ng-container *ngTemplateOutlet="veracodeModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.SONARQUBE">
          <ng-container *ngTemplateOutlet="sonarqubeModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.KNOWBE4">
          <ng-container *ngTemplateOutlet="knowbe4Modal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.GCPSCC">
          <ng-container *ngTemplateOutlet="gcpsccModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="Integration.SERVICENOWCMDB">
          <ng-container *ngTemplateOutlet="servicenowcmdbModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <ng-container *ngTemplateOutlet="normalModal; context: {formData: formData}">
          </ng-container>
        </ng-container>

      </ng-container>

    </div>
  </div>


</div>



<ng-template #normalModal let-formData="formData">
  <form [formGroup]='formData' (ngSubmit)="onSubmit()">

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">URL</label>
          <input type="text" formControlName='url' [placeholder]="placeholder" [ngClass]="{'form-control': true,
                  'error': formData.get('url').touched && !formData.get('url').valid}">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="">Username</label>
          <input type="text" formControlName='username' placeholder='johndoe' [ngClass]="{'form-control': true,
                  'error': formData.get('username').touched && !formData.get('username').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="">Password</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='password'
            autocomplete="off" placeholder='password' [ngClass]="{'form-control': true,
                  'error': formData.get('password').touched && !formData.get('password').valid}">
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #switchableModal let-formData="formData">

  <div class="switch-btns mb-4">
    <button class="switch-btn btn btn-outline-dark mr-2 "
      [ngClass]="{activeColor: currView!=='username'}"
      (click)="toggleTenableSwitch('accessKey')">Access
      Key</button>
    <button class="switch-btn btn btn-outline-dark "
      [ngClass]="{activeColor: currView==='username'}"
      (click)="toggleTenableSwitch('username')">Username</button>
  </div>

  <form [formGroup]='formData' (ngSubmit)="onSubmit()">

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">URL</label>
          <input type="text" formControlName='url' [placeholder]="placeholder" [ngClass]="{'form-control': true,
                  'error': formData.get('url').touched && !formData.get('url').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <ng-container *ngIf="currView==='username'; else accessKeyControl">
            <label for="">Username</label>
            <input type="text" formControlName='username' placeholder='johndoe' [ngClass]="{'form-control': true,
                    'error': formData.get('username').touched && !formData.get('username').valid}">
          </ng-container>
          <ng-template #accessKeyControl>
            <label for="">Access key</label>
            <input type="text" formControlName='accessKey'
              placeholder='z267481232954fefb2010fbd8efa4454d'
              [ngClass]="{'form-control': true,
                    'error': formData.get('accessKey').touched && !formData.get('accessKey').valid}">
          </ng-template>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <ng-container *ngIf="currView==='username'; else apiSecret">
            <label for="">Password</label>
            <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='password'
              autocomplete="off" placeholder='password' [ngClass]="{'form-control': true,
                    'error': formData.get('password').touched && !formData.get('password').valid}">
          </ng-container>
          <ng-template #apiSecret>
            <label for="">Secret Key</label>
            <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='secretKey'
              autocomplete="off" placeholder='21149c7a7f4b4dg45b019gd469f124g664'
              [ngClass]="{'form-control': true,
                    'error': formData.get('secretKey').touched && !formData.get('secretKey').valid}">
          </ng-template>

        </div>
      </div>
    </div>


    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>

  </form>

</ng-template>

<ng-template #azureModal let-formData="formData">
  <form [formGroup]='formData' (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="">Azure Subscription Id</label>
          <input type="text" formControlName='subscriptionId' placeholder='Subscription Id'
            [ngClass]="{'form-control': true,
                  'error': formData.get('subscriptionId').touched && !formData.get('subscriptionId').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="">Tenant Id</label>
          <input type="text" formControlName='tenantId' autocomplete="off" placeholder='Tenant Id'
            [ngClass]="{'form-control': true,
                  'error': formData.get('tenantId').touched && !formData.get('tenantId').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="">Client Id</label>
          <input type="text" formControlName='clientId' placeholder='Client Id' [ngClass]="{'form-control': true,
                  'error': formData.get('clientId').touched && !formData.get('clientId').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="">Client Secret</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='clientSecret'
            autocomplete="off" placeholder='Client Secret'
            [ngClass]="{'form-control': true,
                  'error': formData.get('clientSecret').touched && !formData.get('clientSecret').valid}">
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>


<ng-template #header>
  <div class="setup-banner">
    <span class="setup-banner-title">Integration Setup</span>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span inert>×</span>
    </button>
  </div>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ title | titlecase }} Account Information
    </h4>
  </div>
</ng-template>

<ng-template #footer let-formData="formData">
  <div class="apply-to-section">
    <div class="apply-to-label">Apply this integration to:</div>
    <div class="apply-to-options">
      <label class="apply-to-option" [class.selected]="applyToAll">
        <input type="radio" [name]="'apply-scope-' + serviceType" [checked]="applyToAll"
          (change)="setApplyScope(true)">
        <span class="radio-mark"></span>
        <span class="apply-to-name">Apply to All</span>
      </label>
      <label class="apply-to-option" [class.selected]="!applyToAll">
        <input type="radio" [name]="'apply-scope-' + serviceType" [checked]="!applyToAll"
          (change)="setApplyScope(false)">
        <span class="radio-mark"></span>
        <span class="apply-to-name">{{ isSubEntityLevel ? 'Apply Here' : 'Apply to' }}</span>
      </label>
      <div class="choose-dropdown" *ngIf="!isSubEntityLevel" [class.disabled]="applyToAll">
        <button type="button" class="choose-btn" (click)="toggleSubEntityPicker()">
          {{ !applyToAll && selectedSubEntityCount ? selectedSubEntityCount + ' Selected' : 'Choose'
          }}
          <span class="chevron" [class.open]="showSubEntityPicker"></span>
        </button>
        <div class="choose-panel" *ngIf="showSubEntityPicker">
          <div class="choose-panel-option" *ngFor="let subEntity of subEntities">
            <cygov-checkbox [isChecked]="subEntity.selected" [id]="'apply-to-' + subEntity.id"
              (changed)="toggleSubEntity(subEntity, $event)">
            </cygov-checkbox>
            <span class="apply-to-name">{{ subEntity.name }}</span>
          </div>
          <div class="choose-panel-empty" *ngIf="!subEntities.length">
            {{ subEntitiesLoading ? 'Loading...' : 'No sub-entities available' }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="remove-integration-row" *ngIf="integrationExists">
    <button type="button" class="remove-integration" [disabled]="removeInProgress"
      (click)="confirmRemoveIntegration()" cygovUserPermission [hiddenMode]="1">
      <span class="remove-icon" cygovSvgIcon [svgName]="'trash-icon'"></span>
      <span class="remove-txt">Remove Integration</span>
    </button>
  </div>
  <div class=" modal-footer">
    <div>
      <div class="download-icon" (click)="downloadGuide()" [ngbTooltip]="'Download Guide'"
        placement="top" tooltipClass="integration-guide-tooltip" container="body">
        <span class="lato-12-n-vw">Guide</span>
      </div>
    </div>
    <div>
      <button type="submit" class="btn btn-outline-dark btn-save-run"
        [disabled]='!formData.valid || formDisabled || (hasCredentials && !credentialsRevealed)'
        cygovUserPermission [hiddenMode]="1">Save &
        Run</button>
      <button type="button" (click)="closeModal()"
        class="btn btn-outline-dark btn-cancel">Close</button>
    </div>
  </div>
</ng-template>

<ng-template #awsModal let-formData="formData">
  <form [formGroup]='formData' (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">AWS Role ARN</label>
          <input type="text" formControlName='roleArn' placeholder='Role Arn' [ngClass]="{'form-control': true,
                  'error': formData.get('roleArn').touched && !formData.get('roleArn').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">Region</label>
          <input type="text" formControlName='region' autocomplete="off" placeholder='region'
            [ngClass]="{'form-control': true,
                'error': formData.get('region').touched && !formData.get('region').valid}">
        </div>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="">Client Id</label>
          <input type="text" formControlName='clientId' placeholder='Client Id' [ngClass]="{'form-control': true,
                  'error': formData.get('clientId').touched && !formData.get('clientId').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="">Client Secret</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='clientSecret' autocomplete="off"
            placeholder='Client Secret'
            [ngClass]="{'form-control': true,
                  'error': formData.get('clientSecret').touched && !formData.get('clientSecret').valid}">
        </div>
      </div>
    </div> -->

    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #snykModal let-formData="formData">
  <form [formGroup]="formData" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>API Token</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName="apiToken"
            autocomplete="off" placeholder="Enter Snyk API token" [ngClass]="{'form-control': true,
              'error': formData.get('apiToken').touched && !formData.get('apiToken').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label>Organization ID</label>
          <input type="text" formControlName="orgId" placeholder="Enter Snyk Org ID" [ngClass]="{'form-control': true,
              'error': formData.get('orgId').touched && !formData.get('orgId').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>Base URL</label>
          <input type="text" formControlName="url" placeholder="https://api.snyk.io" [ngClass]="{'form-control': true,
              'error': formData.get('url').touched && !formData.get('url').valid}">
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #intuneModal let-formData="formData">
  <form [formGroup]='formData' (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">Tenant Id</label>
          <input type="text" formControlName='tenantId' autocomplete="off" placeholder='Tenant Id'
            [ngClass]="{'form-control': true,
                  'error': formData.get('tenantId').touched && !formData.get('tenantId').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="">Client Id</label>
          <input type="text" formControlName='clientId' placeholder='Application (Client) Id'
            [ngClass]="{'form-control': true,
                  'error': formData.get('clientId').touched && !formData.get('clientId').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="">Client Secret</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='clientSecret'
            autocomplete="off" placeholder='Client Secret Value'
            [ngClass]="{'form-control': true,
                  'error': formData.get('clientSecret').touched && !formData.get('clientSecret').valid}">
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #sentinelModal let-formData="formData">
  <form [formGroup]='formData' (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="">Tenant Id</label>
          <input type="text" formControlName='tenantId' autocomplete="off"
            placeholder='Directory (Tenant) Id' [ngClass]="{'form-control': true,
                  'error': formData.get('tenantId').touched && !formData.get('tenantId').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="">Subscription Id</label>
          <input type="text" formControlName='subscriptionId' placeholder='Azure Subscription Id'
            [ngClass]="{'form-control': true,
                  'error': formData.get('subscriptionId').touched && !formData.get('subscriptionId').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="">Client Id</label>
          <input type="text" formControlName='clientId' placeholder='Client Id' [ngClass]="{'form-control': true,
                  'error': formData.get('clientId').touched && !formData.get('clientId').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="">Client Secret</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='clientSecret'
            autocomplete="off" placeholder='Client Secret'
            [ngClass]="{'form-control': true,
                  'error': formData.get('clientSecret').touched && !formData.get('clientSecret').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="">Resource Group Name</label>
          <input type="text" formControlName='resourceGroupName' placeholder='Resource Group Name'
            [ngClass]="{'form-control': true,
                  'error': formData.get('resourceGroupName').touched && !formData.get('resourceGroupName').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="">Workspace Name</label>
          <input type="text" formControlName='workspaceName'
            placeholder='Log Analytics Workspace Name'
            [ngClass]="{'form-control': true,
                  'error': formData.get('workspaceName').touched && !formData.get('workspaceName').valid}">
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #sentineloneModal let-formData="formData">
  <form [formGroup]="formData" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>Management URL</label>
          <input type="text" formControlName="url"
            placeholder="https://usea1-partners.sentinelone.net" [ngClass]="{'form-control': true,
              'error': formData.get('url').touched && !formData.get('url').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>API Token</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName="apiToken"
            autocomplete="off" placeholder="Enter API Token" [ngClass]="{'form-control': true,
              'error': formData.get('apiToken').touched && !formData.get('apiToken').valid}">
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #wizModal let-formData="formData">
  <form [formGroup]="formData" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>API Endpoint URL</label>
          <input type="text" formControlName='apiEndpointUrl' autocomplete="off"
            placeholder='https://api.us1.app.wiz.io/graphql'
            [ngClass]="{'form-control': true,
              'error': formData.get('apiEndpointUrl').touched && !formData.get('apiEndpointUrl').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label>Client ID</label>
          <input type="text" formControlName='clientId' placeholder='Client ID' [ngClass]="{'form-control': true,
              'error': formData.get('clientId').touched && !formData.get('clientId').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>Client Secret</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='clientSecret'
            autocomplete="off" placeholder='Client Secret'
            [ngClass]="{'form-control': true,
              'error': formData.get('clientSecret').touched && !formData.get('clientSecret').valid}">
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #splunkModal let-formData="formData">

  <div class="switch-btns mb-4">
    <button class="switch-btn btn btn-outline-dark mr-2"
      [ngClass]="{activeColor: currView==='username'}"
      (click)="toggleTenableSwitch('username')">Username</button>
    <button class="switch-btn btn btn-outline-dark" [ngClass]="{activeColor: currView==='token'}"
      (click)="toggleTenableSwitch('token')">Token</button>
  </div>

  <form [formGroup]='formData' (ngSubmit)="onSubmit()">

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">URL</label>
          <input type="text" formControlName='url' placeholder='https://splunk.example.com:8089'
            [ngClass]="{'form-control': true,
                  'error': formData.get('url').touched && !formData.get('url').valid}">
        </div>
      </div>
    </div>

    <ng-container *ngIf="currView==='username'">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="">Username</label>
            <input type="text" formControlName='username' placeholder='admin' [ngClass]="{'form-control': true,
                    'error': formData.get('username').touched && !formData.get('username').valid}">
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="">Password</label>
            <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='password'
              autocomplete="off" placeholder='password' [ngClass]="{'form-control': true,
                    'error': formData.get('password').touched && !formData.get('password').valid}">
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="currView==='token'">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="">Bearer Token</label>
            <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='bearerToken'
              autocomplete="off" placeholder='Enter Splunk bearer token'
              [ngClass]="{'form-control': true,
                    'error': formData.get('bearerToken').touched && !formData.get('bearerToken').valid}">
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>

  </form>

</ng-template>

<ng-template #oktaModal let-formData="formData">
  <form [formGroup]="formData" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">Okta Domain URL</label>
          <input type="text" formControlName='url' autocomplete="off"
            placeholder='https://your-org.okta.com' [ngClass]="{'form-control': true,
                'error': formData.get('url').touched && !formData.get('url').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">API Token</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='apiToken'
            autocomplete="off" placeholder='Enter API token' [ngClass]="{'form-control': true,
                'error': formData.get('apiToken').touched && !formData.get('apiToken').valid}">
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #orcaModal let-formData="formData">
  <form [formGroup]="formData" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>API Token</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='apiToken'
            autocomplete="off" placeholder='Enter Orca Security API Token' [ngClass]="{'form-control': true,
              'error': formData.get('apiToken').touched && !formData.get('apiToken').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>Base URL</label>
          <input type="text" formControlName='url' placeholder='https://app.us.orcasecurity.io'
            [ngClass]="{'form-control': true,
              'error': formData.get('url').touched && !formData.get('url').valid}">
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #duoModal let-formData="formData">
  <form [formGroup]='formData' (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>API Hostname</label>
          <input type="text" formControlName='apiHostname'
            placeholder='api-XXXXXXXX.duosecurity.com' [ngClass]="{'form-control': true,
              'error': formData.get('apiHostname').touched && !formData.get('apiHostname').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label>Integration Key</label>
          <input type="text" formControlName='integrationKey' placeholder='DIXXXXXXXXXXXXXXXXXX'
            [ngClass]="{'form-control': true,
              'error': formData.get('integrationKey').touched && !formData.get('integrationKey').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>Secret Key</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='secretKey'
            autocomplete="off" placeholder='Secret Key' [ngClass]="{'form-control': true,
              'error': formData.get('secretKey').touched && !formData.get('secretKey').valid}">
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #githubSecurityModal let-formData="formData">
  <form [formGroup]='formData' (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>Personal Access Token</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='token'
            autocomplete="off" placeholder='ghp_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' [ngClass]="{'form-control': true,
              'error': formData.get('token').touched && !formData.get('token').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>Organization</label>
          <input type="text" formControlName='organization' placeholder='my-github-org'
            [ngClass]="{'form-control': true,
              'error': formData.get('organization').touched && !formData.get('organization').valid}">
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #gitlabModal let-formData="formData">
  <form [formGroup]='formData' (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>Personal Access Token</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='token'
            autocomplete="off" placeholder='glpat-xxxxxxxxxxxxxxxxxxxx' [ngClass]="{'form-control': true,
              'error': formData.get('token').touched && !formData.get('token').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>GitLab URL</label>
          <input type="text" formControlName='url' placeholder='https://gitlab.example.com'
            [ngClass]="{'form-control': true,
              'error': formData.get('url').touched && !formData.get('url').valid}">
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #veracodeModal let-formData="formData">
  <form [formGroup]='formData' (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>API URL</label>
          <input type="text" formControlName='url' placeholder='https://api.veracode.com' [ngClass]="{'form-control': true,
              'error': formData.get('url').touched && !formData.get('url').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label>API ID</label>
          <input type="text" formControlName='apiId' placeholder='API ID' [ngClass]="{'form-control': true,
              'error': formData.get('apiId').touched && !formData.get('apiId').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>API Key</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='apiKey'
            autocomplete="off" placeholder='API Key' [ngClass]="{'form-control': true,
              'error': formData.get('apiKey').touched && !formData.get('apiKey').valid}">
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #sonarqubeModal let-formData="formData">
  <form [formGroup]="formData" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">SonarQube Server URL</label>
          <input type="text" formControlName='url' autocomplete="off"
            placeholder='https://sonarqube.example.com' [ngClass]="{'form-control': true,
                'error': formData.get('url').touched && !formData.get('url').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">API Token</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='token'
            autocomplete="off" placeholder='Enter SonarQube user token' [ngClass]="{'form-control': true,
                'error': formData.get('token').touched && !formData.get('token').valid}">
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #knowbe4Modal let-formData="formData">
  <form [formGroup]="formData" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">API Token</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='apiToken'
            autocomplete="off" placeholder='Enter KnowBe4 API token' [ngClass]="{'form-control': true,
                'error': formData.get('apiToken').touched && !formData.get('apiToken').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">Region</label>
          <select formControlName='region' [ngClass]="{'form-control': true,
                'error': formData.get('region').touched && !formData.get('region').valid}">
            <option value="us">US (United States)</option>
            <option value="eu">EU (Europe)</option>
            <option value="ca">CA (Canada)</option>
            <option value="uk">UK (United Kingdom)</option>
            <option value="de">DE (Germany)</option>
          </select>
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #gcpsccModal let-formData="formData">
  <form [formGroup]="formData" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">Service Account Key (JSON)</label>
          <textarea formControlName='serviceAccountKey' rows="6"
            placeholder='Paste your GCP service account key JSON here'
            [ngClass]="{'form-control': true,
                'error': formData.get('serviceAccountKey').touched && !formData.get('serviceAccountKey').valid}">
                      </textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">Organization ID</label>
          <input type="text" formControlName='organizationId'
            placeholder='Enter your GCP Organization ID'
            [ngClass]="{'form-control': true,
                'error': formData.get('organizationId').touched && !formData.get('organizationId').valid}">
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>

<ng-template #servicenowcmdbModal let-formData="formData">
  <form [formGroup]="formData" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">Instance URL</label>
          <input type="text" formControlName='url'
            placeholder='https://your-instance.service-now.com' [ngClass]="{'form-control': true,
                'error': formData.get('url').touched && !formData.get('url').valid}">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label for="">Username</label>
          <input type="text" formControlName='username' placeholder='admin' [ngClass]="{'form-control': true,
                'error': formData.get('username').touched && !formData.get('username').valid}">
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label for="">Password</label>
          <input [type]="credentialsRevealed ? 'text' : 'password'" formControlName='password'
            autocomplete="off" placeholder='password' [ngClass]="{'form-control': true,
                'error': formData.get('password').touched && !formData.get('password').valid}">
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="footer; context: {formData: formData}"></ng-container>
  </form>
</ng-template>